import { createContext, useEffect, useState, useRef, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import {io} from 'socket.io-client'
import api from '../services/api';

 const UserContext = createContext()

 function UserProvider({ children }) {

  const navigate = useNavigate()

  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [pref, setPref] = useState(null);
  const [loading, setLoading] = useState(true);
  const [socket, setSocket] = useState(null);
  const isRefreshing = useRef(false);
  const refreshIntervalRef = useRef(null);

  const logout = useCallback(() => {
    localStorage.removeItem('refreshToken')
    api.defaults.headers['authorization'] = null
    setToken(null)
    setUser(null)
    setPref(null)
    if (refreshIntervalRef.current) clearInterval(refreshIntervalRef.current)
    navigate('/login')
  }, [navigate])

  const handleTokenRefresh = useCallback(async () => {
    const storedRT = localStorage.getItem('refreshToken')
    if (!storedRT || isRefreshing.current) return null
    isRefreshing.current = true
    try {
      const resp = await api.post('/login/refresh', { refreshToken: storedRT })
      if (resp.data.error) {
        logout()
        return null
      }
      const { accessToken, refreshToken: newRT } = resp.data
      api.defaults.headers['authorization'] = `Bearer ${accessToken}`
      localStorage.setItem('refreshToken', newRT)
      setToken(accessToken)
      return accessToken
    } catch (err) {
      console.error('Erro ao renovar token:', err)
      logout()
      return null
    } finally {
      isRefreshing.current = false
    }
  }, [logout])

  async function handleLogin(formData){
    setLoading(true)
    const resp = await api.post("/login/voxcount", formData).catch(err=>{
      alert("Não foi possível fazer o login, tente novamente mais tarde")
    })
    if(resp && resp.data.error){
      alert(resp.data.error)
    }else if(resp){
        let usuario = resp.data.user
        let accessToken = resp.data.accessToken
        let refreshToken = resp.data.refreshToken
        let prefData = resp.data.pref
        api.defaults.headers['authorization'] = `Bearer ${accessToken}`
        localStorage.setItem('refreshToken', refreshToken)
        setToken(accessToken)
        setUser(usuario)
        setPref(prefData)
        navigate('/dashboard')
      }
    setLoading(false)
  }

  function initSocket() { 
    if(socket){
      socket.emit("online")   
      socket.on('lista edited', (list) => {
        let newpref = {...pref}
        newpref.services.voxcount.linkDeRamais = newpref.services.voxcount.linkDeRamais.map(l=>{
          if(l._id === list._id){
            return list
          }else{
            return l
          }
        })
      })
    
      socket.on('lista added', (list) => {
        let newpref = {...pref}
        newpref.services.voxcount.linkDeRamais.push(list)
        setPref(newpref)
      })

      socket.on('lista deleted', (list) => {
        let newpref = {...pref}
        newpref.services.voxcount.linkDeRamais = newpref.services.voxcount.linkDeRamais.filter(l=>l._id !== list._id)
        setPref(newpref)
      })
    }
  }

  function socketsOff(){
    socket.off('lista edited')
    socket.off('lista added')
    socket.off('lista deleted')

  }
  // Interceptor: ao receber 401, tenta refresh automático
  useEffect(() => {
    const interceptor = api.interceptors.response.use(
      response => response,
      async (error) => {
        const originalRequest = error.config
        if (error.response?.status === 401 && !originalRequest._retry) {
          originalRequest._retry = true
          const newToken = await handleTokenRefresh()
          if (newToken) {
            originalRequest.headers['authorization'] = `Bearer ${newToken}`
            return api(originalRequest)
          }
        }
        return Promise.reject(error)
      }
    )
    return () => api.interceptors.response.eject(interceptor)
  }, [handleTokenRefresh])

  // Inicialização: tenta restaurar sessão com refresh token
  useEffect(() => {
    const storedRT = localStorage.getItem('refreshToken')
    if (storedRT) {
      api.post('/login/refresh', { refreshToken: storedRT }).then(resp => {
        if (resp.data.error) {
          logout()
          return
        }
        const { accessToken, refreshToken: newRT } = resp.data
        api.defaults.headers['authorization'] = `Bearer ${accessToken}`
        localStorage.setItem('refreshToken', newRT)
        setToken(accessToken)
        setLoading(false)
      }).catch(() => {
        logout()
        setLoading(false)
      })
    } else {
      setLoading(false)
    }
  }, [])

  // Refresh automático a cada 50 minutos
  useEffect(() => {
    if (token) {
      refreshIntervalRef.current = setInterval(() => {
        handleTokenRefresh()
      }, 50 * 60 * 1000)
    }
    return () => {
      if (refreshIntervalRef.current) clearInterval(refreshIntervalRef.current)
    }
  }, [token, handleTokenRefresh])



  useEffect(() => {
      let newSocket = null
      if(token){
          newSocket = io.connect("wss://vox-ucms-api.voxcity.com.br/", {
              query:{
                  token:token
              }
          })
          setSocket(newSocket);
      }
    return () => {
      if(newSocket){
        newSocket.disconnect()
      }
    }
  }, [token,setSocket])

useEffect(() => {
      if(socket){
          initSocket()
      }
      return () => {
          if(socket){
              socketsOff()
          }
      }
  }, [socket])
  return (
    <UserContext.Provider value={{token, handleLogin, handleTokenRefresh, logout, user, setUser, pref, loading}}>
      {children}
    </UserContext.Provider>
  )
}

export { UserContext, UserProvider }
